<template>
  <div>
    <div class="page-title">Edit Schema</div>
    <Form v-if="form" v-model="form" :submit="update" btnText="Update Schema" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.data-loader.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}” Schema` : `Edit Schema`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async update() {
      await this.$api.DataLoaderSchema.update(this.form);
      this.$router.push("/content-management");
    },
    async setForm() {
      const { data } = await this.$api.DataLoaderSchema.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
